import React from "react";

import Service from "./Service";

import "./home.css";
import Location from "../../images/location.svg";
import Checkout from "../../images/checkout.svg";
import Shopping from "../../images/shoppingbag.svg";

function Services() {
  return (
    <div className="service_container">
      <div className="service_main_div">
        <Service icon={Checkout} />
        <Service icon={Location} />
        <Service icon={Shopping} />
      </div>
    </div>
  );
}

export default Services;
